document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-qty]');
  if (!t) return;
  const input = t.parentElement.querySelector('input[name="quantity"]');
  if (!input) return;
  const n = Math.max(1, (parseInt(input.value,10)||1) + Number(t.dataset.qty));
  input.value = n;
});

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-nav-toggle]');
  if (!btn) return;
  const nav = document.querySelector('[data-nav]');
  if (nav) nav.classList.toggle('is-open');
});

/* Showcase tabs are handled in snippets/home-showcase.liquid — no touch swipe here (preventDefault froze mobile scroll). */

document.querySelectorAll("[data-pdp-tabs]").forEach((root) => {
  const tabs = [...root.querySelectorAll("[data-pdp-tab]")];
  const panels = [...root.querySelectorAll("[data-pdp-panel]")];
  const show = (name) => {
    tabs.forEach((t) => t.classList.toggle("is-on", t.dataset.pdpTab === name));
    panels.forEach((p) => { p.hidden = p.dataset.pdpPanel !== name; });
  };
  tabs.forEach((t) => t.addEventListener("click", () => show(t.dataset.pdpTab)));
  if (location.hash === "#reviews") show("reviews");
});
document.querySelectorAll(".pdp-reviews-link").forEach((a) => {
  a.addEventListener("click", () => {
    const root = document.querySelector("[data-pdp-tabs]");
    if (!root) return;
    root.querySelectorAll("[data-pdp-tab]").forEach((t) => t.classList.toggle("is-on", t.dataset.pdpTab === "reviews"));
    root.querySelectorAll("[data-pdp-panel]").forEach((p) => { p.hidden = p.dataset.pdpPanel !== "reviews"; });
  });
});
